<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <path
      d="M11.0146 3.98535L19.0146 11.9854L11.0146 19.9854"
      :class="[`${styles}`]"
      stroke-width="3"
    />
    <path d="M18 12L2 12" stroke-width="3" :class="[`${styles}`]" />
  </svg>
</template>

<script lang="ts" setup>
import { toRefs } from "vue";

const props = withDefaults(defineProps<{ styles?: string }>(), {
  styles: "stroke-orange",
});

const { styles } = toRefs(props);
</script>
